module.exports = __webpack_public_path__ + "img/logos.7927b571.png";